import * as yup from 'yup';

export const CALENDAR_SCHEMA = yup.object().shape({
    title: yup.string().required(),
    location: yup.string().optional(),
    country_id: yup.string().optional(),
    description: yup.string().optional(),
    all_day: yup.boolean().optional(),
    start_date: yup.date().required(),
    end_date: yup.date().required(),
    start_time: yup.string().nullable(),
    end_time: yup.string().nullable(),
    notes: yup
        .array()
        .of(
            yup.object().shape({
                note: yup.string().optional()
            })
        )
        .optional(),
    participants: yup
        .array()
        .of(
            yup.object().shape({
                first_name: yup.string().optional(),
                last_name: yup.string().optional(),
                role: yup.string().optional()
            })
        )
        .optional(),
    shared: yup.boolean().required(),
    shared_organizations: yup.array().of(yup.string()).optional(),
    shared_users: yup.array().of(yup.string()).optional(),
    is_recurrent: yup.boolean().required('You need to specify if the event is recurrent or not'),
    frequency: yup
        .string()
        .required('Frequency is required')
        .oneOf(['daily', 'weekly', 'monthly', 'yearly'], 'Invalid frequency value'),
    week_days: yup
        .array()
        .of(yup.string().matches(/^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)$/, 'Invalid day'))
        .test('is-required-for-weekly', 'Please select at least one day for weekly recurrence', function (value) {
            if (this.parent.frequency === 'weekly') {
                return Array.isArray(value) && value.length > 0;
            }
            return true;
        }),
    month_days: yup
        .array()
        .of(yup.number().min(1, 'Day must be at least 1').max(31, 'Day must not exceed 31'))
        .test('is-required-for-monthly', 'Please select at least one day for monthly recurrence', function (value) {
            if (this.parent.frequency === 'monthly') {
                return Array.isArray(value) && value.length > 0;
            }
            return true;
        }),
    recurrence_end_type: yup
        .string()
        .oneOf(['never', 'on'], 'Invalid recurrence end type')
        .required('Recurrence end type is required'),

    recurrence_end_date: yup
        .string()
        .nullable()
        .test('is-required-for-on', 'End date is required', function (value) {
            if (this.parent.recurrence_end_type === 'on') {
                return !!value && value.trim() !== '';
            }
            return true;
        })
});

export const getStatusColor = (status) => {
    switch (status) {
        case 'confirmed':
            return 'bg-theme1-success';
        case 'proposed':
            return 'bg-theme1-info';
        case 'attempted':
            return 'bg-theme1-warning';
        case 'canceled':
            return 'bg-theme1-canceled';
        default:
            return 'bg-theme1-gold1';
    }
};

export const formatStatus = (status) => {
    let processedStatus = status !== 'attempted' ? status : 'tentative';

    return processedStatus
        .split('-')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};
